<template>
    <div class="video-container">
      <div class="video-wrapper">
        <BaseEmpty v-if="!current || !current.video_url || !current.siblings || current.siblings.length == 0" class="empty-state">
          <BaseLoading v-if="loading" />
          <template v-else>
            <div class="empty-content">
              <div class="empty-icon">📹</div>
              <div class="empty-text">本专辑还未上传视频</div>
            </div>
          </template>
        </BaseEmpty>
        <template v-else>
          <div class="video-player-wrapper">
            <video 
              :src="current.video_url" 
              class="video-player" 
              controls 
              controlsList="nodownload"
              :poster="current.cover_url"
            ></video>
            <div class="video-info" v-if="current.name">
              <h2 class="video-title">{{ current.name }}</h2>
              <p class="video-description" v-if="current.description">{{ current.description }}</p>
            </div>
          </div>
          
          <div class="playlist" v-if="current.siblings && current.siblings.length > 0">
            <div class="playlist-header">
              <div class="playlist-title">
                <span class="playlist-icon">📑</span>
                <span>播放列表</span>
              </div>
              <div class="playlist-count">共 {{ current.siblings.length }} 集</div>
            </div>
            <div class="playlist-content">
              <div 
                v-for="(r, index) in current.siblings" 
                :key="r.id"
                :class="{
                  'playlist-item': true,
                  'playlist-item-active': r.id == current.id
                }"
                @click="changeVideo(r)"
              >
                <div class="playlist-item-index">{{ index + 1 }}</div>
                <div class="playlist-item-content">
                  <div class="playlist-item-name">{{ r.name }}</div>
                  <div class="playlist-item-duration" v-if="r.duration">{{ r.duration }}</div>
                </div>
                <div class="playlist-item-icon" v-if="r.id == current.id">
                  <span class="playing-icon">▶</span>
                </div>
              </div>
            </div>
          </div>
        </template>
      </div>
    </div>
  </template>
  
  <script>
  export default {
      data(){
          return {
              loading:false
          }
      },
      computed:{
          id(){
              return this.$route.query.id
          }
      },
      mounted(){
          this.getData()
      },
      methods:{
          getData(){
              this.loading = true
              this.$api.get('public/classes/'+this.id).then((res)=>{
                  this.current = res.data.data
              }).finally(()=>{
                  this.loading = false
              })
          },
          changeVideo(video){
              this.current = {
                  ...video,
                  siblings: this.current.siblings
              }
              // 滚动到视频顶部
              if(window.innerWidth <= 768){
                  window.scrollTo({ top: 0, behavior: 'smooth' })
              }
          }
      }
  }
  </script>
  
  <style scoped>
  .video-container {
    width: 100%;
    height: 100%;
    overflow: auto;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    background: var(--background, #f5f7fa);
    padding: 20px;
    box-sizing: border-box;
  }
  
  .video-wrapper {
    max-width: 1400px;
    margin: 0 auto;
    display: flex;
    gap: 20px;
    align-items: flex-start;
  }
  
  /* 空状态样式 */
  .empty-state {
    width: 100%;
    min-height: 500px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
  }
  
  .empty-content {
    text-align: center;
  }
  
  .empty-icon {
    font-size: 64px;
    margin-bottom: 16px;
    opacity: 0.5;
  }
  
  .empty-text {
    font-size: 16px;
    color: #999;
  }
  
  /* 视频播放器区域 */
  .video-player-wrapper {
    flex: 1;
    min-width: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    overflow: hidden;
  }
  
  .video-player {
    width: 100%;
    display: block;
    background: #000;
    max-height: 70vh;
    object-fit: contain;
  }
  
  .video-info {
    padding: 20px;
    border-top: 1px solid #eee;
  }
  
  .video-title {
    margin: 0 0 8px 0;
    font-size: 20px;
    font-weight: 600;
    color: #333;
  }
  
  .video-description {
    margin: 0;
    font-size: 14px;
    color: #666;
    line-height: 1.6;
  }
  
  /* 播放列表区域 */
  .playlist {
    width: 320px;
    flex-shrink: 0;
    background: white;
    border-radius: 12px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.08);
    max-height: 80vh;
    display: flex;
    flex-direction: column;
    overflow: hidden;
  }
  
  .playlist-header {
    padding: 16px 20px;
    border-bottom: 2px solid #f0f0f0;
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
  }
  
  .playlist-title {
    display: flex;
    align-items: center;
    gap: 8px;
    font-size: 16px;
    font-weight: 600;
  }
  
  .playlist-icon {
    font-size: 20px;
  }
  
  .playlist-count {
    font-size: 12px;
    opacity: 0.9;
    background: rgba(255, 255, 255, 0.2);
    padding: 4px 10px;
    border-radius: 12px;
  }
  
  .playlist-content {
    overflow-y: auto;
    flex: 1;
  }
  
  .playlist-item {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 12px 16px;
    cursor: pointer;
    transition: all 0.3s ease;
    border-bottom: 1px solid #f5f5f5;
  }
  
  .playlist-item:hover {
    background: #f8f9ff;
    transform: translateX(4px);
  }
  
  .playlist-item-active {
    background: linear-gradient(90deg, #667eea15 0%, #764ba215 100%);
    border-left: 3px solid #667eea;
  }
  
  .playlist-item-active:hover {
    background: linear-gradient(90deg, #667eea20 0%, #764ba220 100%);
  }
  
  .playlist-item-index {
    width: 28px;
    height: 28px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #f0f0f0;
    border-radius: 50%;
    font-size: 12px;
    font-weight: 600;
    color: #666;
    flex-shrink: 0;
  }
  
  .playlist-item-active .playlist-item-index {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
  }
  
  .playlist-item-content {
    flex: 1;
    min-width: 0;
  }
  
  .playlist-item-name {
    font-size: 14px;
    color: #333;
    margin-bottom: 4px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }
  
  .playlist-item-active .playlist-item-name {
    color: #667eea;
    font-weight: 600;
  }
  
  .playlist-item-duration {
    font-size: 12px;
    color: #999;
  }
  
  .playlist-item-icon {
    flex-shrink: 0;
  }
  
  .playing-icon {
    color: #667eea;
    font-size: 14px;
    animation: pulse 1.5s ease-in-out infinite;
  }
  
  @keyframes pulse {
    0%, 100% {
      opacity: 1;
    }
    50% {
      opacity: 0.5;
    }
  }
  
  /* 移动端适配 */
  @media screen and (max-width: 768px) {
    .video-container {
      padding: 0;
      background: white;
    }
  
    .video-wrapper {
      flex-direction: column;
      gap: 0;
    }
  
    .video-player-wrapper {
      width: 100%;
      border-radius: 0;
      box-shadow: none;
    }
  
    .video-player {
      max-height: 40vh;
      border-radius: 0;
    }
  
    .video-info {
      padding: 16px;
    }
  
    .video-title {
      font-size: 18px;
    }
  
    .playlist {
      width: 100%;
      border-radius: 0;
      box-shadow: none;
      max-height: none;
      border-top: 8px solid #f5f5f5;
    }
  
    .playlist-header {
      border-radius: 0;
      padding: 14px 16px;
    }
  
    .playlist-item {
      padding: 14px 16px;
    }
  
    .playlist-item:hover {
      transform: none;
    }
  
    .playlist-item:active {
      background: #f0f0f0;
    }
  }
  
  /* 小屏幕适配 */
  @media screen and (max-width: 480px) {
    .video-info {
      padding: 12px;
    }
  
    .video-title {
      font-size: 16px;
    }
  
    .video-description {
      font-size: 13px;
    }
  
    .playlist-header {
      padding: 12px;
    }
  
    .playlist-title {
      font-size: 14px;
    }
  
    .playlist-item {
      padding: 12px;
      gap: 8px;
    }
  
    .playlist-item-index {
      width: 24px;
      height: 24px;
      font-size: 11px;
    }
  
    .playlist-item-name {
      font-size: 13px;
    }
  }
  
  /* 滚动条美化 */
  .playlist-content::-webkit-scrollbar {
    width: 6px;
  }
  
  .playlist-content::-webkit-scrollbar-track {
    background: #f5f5f5;
  }
  
  .playlist-content::-webkit-scrollbar-thumb {
    background: #ddd;
    border-radius: 3px;
  }
  
  .playlist-content::-webkit-scrollbar-thumb:hover {
    background: #ccc;
  }
  </style>